import React, { lazy, Suspense, useState, useEffect } from 'react'
import { useQuery, gql } from "@apollo/client";
import { Helmet } from "react-helmet"
import Footer from "./Footer";
import Header from "./header";
const SectionCta = lazy(() => import("./newComponents/sectionCta").then((module) => ({ default: module.SectionCta }))); 
import CookieNotice from "./CookieNotice"

import "@fontsource/lato/300.css"
import "@fontsource/lato/400.css"
import "@fontsource/lato/700.css"
import "@fontsource/lato/900.css"

import "@fontsource/roboto/900.css"
import "@fontsource/roboto/700.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/300.css"

const Layout = ({ children, sidebar, pageContext, customNavLogo, customClassName }) =>
{
    const currentHostname = typeof window !== `undefined` ? window.location.hostname : "nohostname";
    const [navActive, setNavActive] = useState(false);

    useEffect(() => {
        function handleResize() {
            const { innerWidth: width, innerHeight: height } = window;
            console.log(width);
            if(width > 1024) {
                setNavActive(false);
            }
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

  return (
    <div className={`h-full flex flex-col font-body antialiased font-normal${navActive ? " nav-active" : ""}${sidebar ? " overflow-x-hidden" : ""} ${customClassName ?? ""}`}>
      <Helmet>
        <html lang="en" />
        <meta content="IE=edge" http-equiv="X-UA-Compatible"/>
        <meta charset="utf-8"/>
        <meta name="description" content="Genesis Analytics - Data-driven insights and analytics solutions for business transformation" />
        <meta content="width=device-width, initial-scale=1.0, maximum-scale=5.0, viewport-fit=cover" name="viewport"/>
        <meta content="origin-when-cross-origin" name="referrer" />
        <link rel="apple-touch-icon"sizes="180x180" href="/apple-touch-icon.png"/>
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"/>
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"/>
        <meta name="google-site-verification" content="rAVWpdxypv5OK5bALpX3Ge7c-cyRAY7WtuUoxo2djF4" />
        {currentHostname === "localhost" || currentHostname === "genesis2.gatsbyjs.io" || currentHostname === "genesis2.gtsb.io" || currentHostname === "preview-genesis2.gtsb.io" || currentHostname ==="test.genesis-analytics.com" ? <meta name="robots" content="noindex"/> : <meta/>}
      </Helmet>
      <div>
        <Header setNavActive={setNavActive} pageContext={pageContext} customNavLogo={customNavLogo}/>
        <div className="wrapper">
          <div className="wrapper__inner">        
            <div className="overlay js-overlay" />
            {children}
            <Suspense fallback={<></>}><SectionCta/></Suspense>
            <Footer/>
          </div>
        </div>
        <CookieNotice/>
      </div>
    </div>
  )
}

export default Layout;
